<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.zsth">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">罩式退火炉</span>
        </b>
      </p>
      <p>
        <br>
      </p>
      <p style="background:white;">
        <span style="color:black;">我公司产品远销乌克兰等国家。</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">&nbsp;</span>
      </p>
      <p style="background:white;">
        <span style="color:black;">一、</span>
        <b>
          <span style="font-family:Arial;color:#213C70;">
            <a href="http://www.dyhengli.com/zhaoshilu">
              <span style="font-family:宋体;">
                <span>光亮罩式炉</span>
              </span>
            </a>
          </span>
        </b>
        <span
          style="color:black;"
        >主要适用于黄铜、青铜、紫铜、各类精密铜管、造币材料、精密带钢、复合带材、软磁和硬磁合金、铜合金线材、标准件材料、不锈钢带等几十种材料。</span>
        <span style="font-family:Arial;color:black;"></span>
        <span style="color:black;">光亮罩式炉最大装料直径</span>
        <span style="font-family:Arial;color:black;">3.2M</span>
        <span style="color:black;">，装料高度最高达</span>
        <span style="font-family:Arial;color:black;">4M</span>
        <span style="color:black;">，最大装炉量</span>
        <span style="font-family:Arial;color:black;">80T</span>
        <span style="color:black;">。</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">&nbsp;</span>
      </p>
      <p style="background:white;">
        <span style="color:black;">二、</span>
        <span style="font-family:Arial;color:black;">
          <a href="http://www.dyhengli.com/zhaoshilu">
            <strong>
              <span style="font-family:宋体;">
                <span>光亮罩式炉</span>
              </span>
            </strong>
          </a>
        </span>
        <span style="color:black;">由一个加热罩、两个炉座、两个内罩和阀架等组成：</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">
          <span>&nbsp;</span>
        </span>
      </p>
      <p style="background:white;">
        <span style="color:black;">三、电气控制柜采用</span>
        <span style="font-family:Arial;color:black;">PID</span>
        <span style="color:black;">过零触发温控调节仪来调节炉内的功率和温度，并安装有超温报警功能</span>
        <span style="font-family:Arial;color:black;"></span>
        <span style="color:black;">。并可根据用户需要制作上位机，组态软件动态显示。</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p style="background:white;">
        <span style="font-family:Arial;color:black;">&nbsp;</span>
      </p>
      <p style="background:white;">
        <span style="color:black;">具体可按客户工件产品要求设计定做。</span>
        <span style="font-family:Arial;color:black;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <img :src="images.zsth2" alt style="white-space:normal;">
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        zsth: require("../../../assets/img/common/zsth.jpg"),
        zsth2: require("../../../assets/img/common/zsth2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/zsth.vue